import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { hexToRgbA, StylesIndexInjections } from 'common-react';

interface StyleProps {
  labelPlacement?: 'start' | 'end';
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    width: 44,
    height: 24,
    padding: 0,

    '& .MuiButtonBase-root': {
      position: 'absolute',
      padding: 2,
    },
    '& .MuiSwitch-colorSecondary.Mui-checked:hover': {
      backgroundColor: 'transparent',
    },
  },

  formControlLabel: {
    marginLeft: 0,
    gap: 4,

    '& .MuiFormControlLabel-label': {
      marginLeft: (props: StyleProps) => props.labelPlacement === 'end' ? 8 : 0,
      marginRight: (props: StyleProps) => props.labelPlacement === 'start' ? 8 : 0,
    },

    '&:not(.Mui-disabled):hover': {
      backgroundColor: hexToRgbA(theme.color.greys[80], 0.08),
    },

    '&:not(.Mui-disabled):active': {
      backgroundColor: hexToRgbA(theme.color.greys[80], 0.16),
    },

    '&:focus-within:has(.Mui-focusVisible)': {
      outline: `2px solid ${theme.color.greys[80]}`,
      outlineOffset: 2,
      borderRadius: 5,
    },
  },

  thumb: {
    position: 'relative',
    boxShadow: 'none',
    width: 20,
    height: 20,
  },

  switchBase: {
    '&$checked': {
      transform: 'translateX(10px)',

      '& $thumb': {
        backgroundColor: theme.color.constants.greys[0],
        left: 10,
      },

      '& + $track': {
        backgroundColor: theme.color.greens[100],
        border: `1px solid ${theme.color.greens[100]}`,
        opacity: 1,
      },
    },

    '&$disabled': {
      '& $thumb': {
        backgroundColor: theme.color.constants.greys[0],
      },
      '& + $track': {
        backgroundColor: hexToRgbA(theme.color.greys[75], 0.4),
        border: `1px solid ${hexToRgbA(theme.color.greys[75], 0.4)}`,
      },
    },

    '&$checked$disabled': {
      transform: 'translateX(10px)',
      '& $thumb': {
        backgroundColor: theme.color.constants.greys[0],
        left: 10,
      },
      '& + $track': {
        backgroundColor: hexToRgbA(theme.color.greens[100], 0.4),
        border: `1px solid ${hexToRgbA(theme.color.greens[100], 0.4)}`,
      },
    },
  },
  track: {
    backgroundColor: theme.color.greys[75],
    border: `1px solid ${theme.color.greys[75]}`,
    borderRadius: 24,
    opacity: 1
  },

  checked: {},
  disabled: {},
}), { name: 'Switch', index: StylesIndexInjections.UI_ATOMS });
